import { Drawer, DrawerTitle } from '@rocketlane/ui';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { AddAiPages, AiPagesPayload } from './ai-pages';

interface Props {
  open: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AiPagesPayload) => Promise<void>;
}
export const AddAiPagesDrawer: FC<Props> = ({
  open,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer size="672px" placement="right" open={open} onClose={onClose}>
      <DrawerTitle className="sr-only">
        <FormattedMessage id="knowledge_base.ai_pages.title" />
      </DrawerTitle>
      <AddAiPages onClose={onClose} onNext={onDone} breadcrumbs={breadcrumbs} />
    </Drawer>
  );
};
